import React from 'react';
import { ScoreItem } from '@talentmesh/utils';
import { TestTypes } from '@/Models/Configuration';
import { useCandidatesResultsContext } from '../../Contexts/CandidateResultsContext';
import BenchmarkPanel from './Components/Benchmark/BenchmarkPanel';
import ScoreOverview from './Components/ScoreOverview';
import UIStrings from '@/Utils/UIStrings';

function AptitudeTab(): React.JSX.Element | null {
    const { results } = useCandidatesResultsContext();
    const { aptitudeScore, candidateFirstName } = results;

    if (!aptitudeScore) {
        return null;
    }

    const { percentileScore, percentileLevel } = aptitudeScore;

    const overall: ScoreItem = {
        level: percentileLevel,
        name: UIStrings.OverallScore,
        value: percentileScore,
    };

    const scores: ScoreItem[] = aptitudeScore.scores.map((score) => {
        return {
            level: score.percentileLevel,
            name: score.questionTopicName,
            value: score.percentileScore,
        };
    });

    return (
        <div className="mb-5 flex flex-col gap-5">
            <ScoreOverview
                scoreOverviewTitle={UIStrings.AptitudeScoreOverview}
                scoreOverviewDescription={UIStrings.TheOverallScoreIsCalculatedBasedOnAptitude}
                candidateFirstName={candidateFirstName}
                scores={scores}
                overall={overall}
            />
            <BenchmarkPanel
                candidateFirstName={candidateFirstName}
                testType={TestTypes.Aptitude}
                candidateScore={aptitudeScore}
            />
        </div>
    );
}

export default AptitudeTab;
